import { PropsWithChildren } from 'react';
import { cn } from '@antimatterhq/ui/lib/utils';

export type TextProps = {
  color?: Color;
  size?: Size;
} & (
  | { bold?: false; semiBold?: false }
  | { bold: true; semiBold?: false }
  | { bold?: false; semiBold: true }
) &
  React.HTMLAttributes<HTMLSpanElement>;

export default function Text({
  color,
  size,
  bold,
  semiBold,
  children,
  className,
  ...props
}: TextProps & PropsWithChildren) {
  return (
    <span
      className={cn(
        (!color || color === 'primary') && 'text-grey-800 dark:text-grey-100',
        color === 'secondary' && 'text-grey-500 dark:text-grey-350',
        color === 'info' && 'text-grey-500 dark:text-grey-400',
        color === 'error' && 'text-red-600 dark:text-red-500',
        color === 'success' && 'text-green-600 dark:text-green-500',
        color === 'warning' && 'text-yellow-600 dark:text-yellow-500',
        (!size || size === 'sm') && 'text-sm',
        size === 'base' && 'text-base',
        size === 'lg' && 'text-lg',
        size === 'xl' && 'text-xl',
        size === '2xl' && 'text-2xl',
        size === '3xl' && 'text-3xl',
        bold && 'font-bold',
        semiBold && 'font-semibold',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
